module.exports = __webpack_public_path__ + "static/media/marron.8846ca32.png";